var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.8036,
    height: 38,
    rx: 19,
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 26.1638C22.7828 26.1638 26.4198 20.652 26.4198 15.8724C26.4198 15.7159 26.4166 15.56 26.4095 15.4049C27.1172 14.8926 27.7279 14.2584 28.2131 13.5319C27.5653 13.82 26.8681 14.0139 26.1367 14.1014C26.8832 13.6536 27.4563 12.9452 27.7267 12.1008C27.017 12.522 26.2405 12.8189 25.4308 12.9787C24.771 12.2757 23.8316 11.8359 22.7915 11.8359C20.7948 11.8359 19.1756 13.4558 19.1756 15.4525C19.1756 15.7363 19.2073 16.0124 19.2694 16.2772C16.2643 16.126 13.5996 14.6866 11.8162 12.4981C11.495 13.0501 11.3261 13.6774 11.3267 14.3161C11.3267 15.571 11.965 16.6788 12.9357 17.3269C12.3615 17.3094 11.7999 17.1542 11.2981 16.8745C11.2976 16.8897 11.2976 16.9045 11.2976 16.9207C11.2976 18.6724 12.5439 20.135 14.1984 20.4664C13.8876 20.551 13.567 20.5938 13.2449 20.5936C13.0124 20.5936 12.7857 20.5707 12.5654 20.5284C13.0257 21.9656 14.3605 23.0114 15.9431 23.0407C14.7055 24.011 13.1466 24.5889 11.4523 24.5889C11.1641 24.5892 10.8761 24.5724 10.5898 24.5388C12.1901 25.5649 14.0901 26.1636 16.1324 26.1636",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRounded);
export default __webpack_public_path__ + "static/media/twitter-rounded.b4b030c0802cd312c314b1ba6a69f279.svg";
export { ForwardRef as ReactComponent };